import "../../../App.css";
import {Button, Descriptions, Form, Input, Layout, message, Modal, Result, Typography} from "antd";
import "antd/dist/reset.css";
import {useOrderId} from "../../../hooks/UseOrderId";
import {Copyable} from "../../common/Copyable";
import {PaymentType} from "../../../App";
import WrappedCard from "../../antd/WrappedCard";
import React, {useState} from "react";
import {ProviderTypeEnum} from "../../../types/ProviderTypeEnum";
import useAxios from "axios-hooks";
import {CheckoutSubmissionRequest} from "../../../types/CheckoutSubmissionRequest";
import teachingVideo from "../../../assets/bankCardTeching.mp4";

const {Content} = Layout;

// NOTICE: GET目前是同步的，后面有可能会需要支援非同步，近来收银台后先转圈等到GET有结果
function PkSadapayMode({getCheckoutInfoData}: PaymentType) {
    const id = useOrderId();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [form] = Form.useForm();
    const [messageApi] = message.useMessage();
    const [submitCheckout, setSubmitCheckout] = useState(getCheckoutInfoData?.checkoutStatus === "SUBMITTED");
    const [isFormValid, setIsFormValid] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [{data: putData}, executePost] =
        useAxios<CheckoutSubmissionRequest>(
            {
                url: `/v2/checkout/${id}`,
                method: "POST"
            },
            {manual: true}
        );
    console.log("[POST] checkout.putData", putData);

    const onFormFinish = (values: any) => {
        setSubmitCheckout(true);

        executePost({
            data: {
                id: id,
                providerType: ProviderTypeEnum.BANK,
                providerName: 'sadapay',
                customerAccount: values.customerAccount,
                customerName: values.customerName,
                reserved1: getCheckoutInfoData?.reserved1,
            }
        })
            .then(() => {
                messageApi.info("Submit Success");
            })
            .catch((error) => {
                messageApi.error("Failed:" + error?.response?.data?.title);
                setSubmitCheckout(false);
            })
            .finally(() => {
            });
    };

    const onButtonClick = () => {
        setIsSubmitting(true);
        form.submit();
    };

    const checkFormValidity = () => {
        form.validateFields()
            .then(() => {
                setIsFormValid(true);
            })
            .catch(() => {
                setIsFormValid(false);
            });
    }

    return (
        <>
            <Content>
                <WrappedCard cardTitle="Information">
                    <>
                        <div style={{fontSize: 16, color: "blue", width: "100%"}}>
                            Step 1. Fill in payment information <br/>
                            Step 2. Submit <br/>
                            Step 3. Please transfer fund to the following SadaPay account <br/>
                            {/*<Button style={{fontSize: 16, color: "white", background: "#1677ff", textAlign: "center"}} onClick={() => {setShowModal(true)}}>How to do it?</Button>*/}
                            {/*<Modal*/}
                            {/*    open={showModal}*/}
                            {/*    closable={false}*/}
                            {/*    onCancel={() => {*/}
                            {/*        setShowModal(false)*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    <video controls width="100%">*/}
                            {/*        <source src={teachingVideo} type="video/mp4"/>*/}
                            {/*        Your browser does not support the video tag.*/}
                            {/*    </video>*/}
                            {/*</Modal>*/}

                            <br/>
                        </div>
                    </>
                </WrappedCard>
            {/*NOTICE: 訂單未完成*/}
            {getCheckoutInfoData?.checkoutStatus === "VISITED" && !submitCheckout && (
                    <WrappedCard>
                        <Form
                            form={form}
                            onFinish={onFormFinish}
                            onChange={checkFormValidity}
                        >
                            <>
                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <td>Wallet account name</td>
                                        <td align="right">والیٹ اکاؤنٹ کا نام</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </>
                            <Form.Item name="customerName"
                                       rules={[{
                                           required: true,
                                           message: "Please insert correct name"
                                       }]}
                            >
                                <Input/>
                            </Form.Item>

                            <>
                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <td>Wallet account number</td>
                                        <td align="right">والٹ اکاؤنٹ نمبر</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </>
                            <Form.Item name="customerAccount"
                                       rules={[{
                                           required: true,
                                           message: "Please insert correct account"
                                       }]}>
                                <Input/>
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" onClick={onButtonClick} disabled={!isFormValid}>
                                    {isSubmitting ? "Submitting..." : "Submit"}
                                </Button>
                            </Form.Item>
                        </Form>
                    </WrappedCard>
            )}

            {/*NOTICE: 使用者填寫完畢送出，會看到等待付款中狀態頁面。*/}
            {submitCheckout && (
              <Descriptions title={
                  <>
                      <table width="100%">
                          <tbody>
                          <tr>
                              <td>Bank Information</td>
                              <td align="right">بینک کی معلومات</td>
                          </tr>
                          </tbody>
                      </table>
                  </>
              } bordered>
                  <Descriptions.Item label={
                      <>
                          Amount<br />
                          قابل ادائیگی رقم
                      </>
                  }>
                      <Typography.Title
                        copyable={{icon: <Copyable/>}}
                        level={5}
                        style={{margin: 0}}
                      >
                          {getCheckoutInfoData?.orderAmount}
                      </Typography.Title>
                  </Descriptions.Item>

                  <Descriptions.Item label={
                      <>
                          Bank Account<br />
                          بینک اکاؤنٹ
                      </>
                  }>
                      <Typography.Title
                        copyable={{icon: <Copyable/>}}
                        level={5}
                        style={{margin: 0}}
                      >
                          {getCheckoutInfoData?.receiverAccount}
                      </Typography.Title>
                  </Descriptions.Item>

                  <Descriptions.Item label={
                      <>
                          Bank Name<br />
                          بینک کا نام
                      </>
                  }>
                      <Typography.Title
                        copyable={{icon: <Copyable/>}}
                        level={5}
                        style={{margin: 0}}
                      >
                          {getCheckoutInfoData?.receiverBank}
                      </Typography.Title>
                  </Descriptions.Item>

                  {getCheckoutInfoData?.receiverBranchBank && (<Descriptions.Item label={
                      <>
                          Branch Bank Name<br />
                          بینک برانچ کا نام
                      </>
                  }>
                      <Typography.Title
                        copyable={{icon: <Copyable/>}}
                        level={5}
                        style={{margin: 0}}
                      >
                          {getCheckoutInfoData?.receiverBranchBank}
                      </Typography.Title>
                  </Descriptions.Item>)}
                  {getCheckoutInfoData?.receiverBranchCode && (<Descriptions.Item label={
                      <>
                          Account Name<br />
                          کھاتے کا نام
                      </>
                  }>
                      <Typography.Title
                        copyable={{icon: <Copyable/>}}
                        level={5}
                        style={{margin: 0}}
                      >
                          {getCheckoutInfoData?.receiverName}
                      </Typography.Title>
                  </Descriptions.Item>)}
              </Descriptions>
            )}
            </Content>
        </>
    );
}

export default PkSadapayMode;
